export default "__VITE_ASSET__CFK_xCge__"